export const bracketsRegEx = /(\[\[[a-zA-Z0-9\s\-_]+\]\])/g
const bracketsReplacementRegEx = /[\[\]]/g // eslint-disable-line no-useless-escape
const bracesRegEx = /\{(\s|\S)+?\}/g
const bracesReplacementRegEx = /[{}]/g

/**
 * Translates template texts with multiple translation keys in an easy way.
 * translation keys are given in curly braces: {key1} {key2} etc.
 * For example '{summaryTitle} - {serviceName}' will be translated to ´Yhteenveto - Holhoustoimen lupahakemus'
 * when given holhous translations, fi language and previously mentioned template text
 * @param translations
 * @param lang
 * @param templateText
 * @returns template text translated using given translations and language
 */

export function translateTemplate({ translations, lang, templateText }) {
  const translate = translations.getFixedT(lang)
  return templateText.replace(bracesRegEx, (placeholder) => {
    const word = placeholder.replace(bracesReplacementRegEx, '')
    return translate(word)
  })
}

/**
 * compiles template with "[[ ]]" tags like common-ui-components/src/vtj/localized-string/LocalizedString.react.js
 * Value keys are given in double brackets like in LocalizedString.react.js: [[key1]] [[key2]] etc.
 * For example '[[summaryTitle]] - [[serviceName]]' will be replaced with values[summaryTitle] and values[serviceName]
 */

export function compileTemplate({ template, values }) {
  return template.replace(bracketsRegEx, (placeholder) => {
    const word = placeholder.replace(bracketsReplacementRegEx, '')
    return values[word] || word
  })
}
